<template>
  <el-table v-bind="$attrs">
    <el-table-column prop="productId" label="游戏ID" width="90"></el-table-column>
    <el-table-column prop="productName" show-overflow-tooltip label="游戏名称"></el-table-column>
    <el-table-column prop="platform" label="平台" width="60">
      <template slot-scope="{ row }">
        {{ getPlatform(row) }}
      </template>
    </el-table-column>
    <el-table-column prop="gameAddress" show-overflow-tooltip label="路径/下载地址"></el-table-column>
    <el-table-column label="渠道分成比例" show-overflow-tooltip>
      <template slot-scope="{ row }">
        {{ getShareRate(row) }}
      </template>
    </el-table-column>
    <el-table-column label="操作" width="100">
      <template slot-scope="{ row }">
        <slot :row="row"></slot>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { PLATFORM, PLATFORM_LIST } from '../../consts/index.js'

function getShareRate(row) {
  const { platform, channelAdjustStatus } = row
  if (platform === PLATFORM.MINIPROGRAM) {
    if (channelAdjustStatus === 1) {
      const { androidMoneyAdjust, iosMoneyAdjust } = row
      const androidRate = Number.isFinite(androidMoneyAdjust) ? (androidMoneyAdjust * 100).toFixed(2) + '%' : '-'
      const iosRate = Number.isFinite(iosMoneyAdjust) ? (iosMoneyAdjust * 100).toFixed(2) + '%' : '-'
      return `安卓：${androidRate}，IOS：${iosRate}`
    }

    return '渠道分成比例：关闭'
  }
  return '-'
}

function getPlatform(row) {
  const platform = PLATFORM_LIST.find((item) => item.value === row.platform)
  return platform ? platform.label : ''
}
</script>

<style scoped lang="scss"></style>
